import EventEmitter from '@tencent/ovb-event-emitter';
import jsonTool from './jsontool';
/**
 * 创建”函数调用日志装饰器“
 * @param scope 函数作用域名，传入成员函数所在的类名
 * @returns MethodDecorator
 */
export function logMethodCallDecoratorCreator(scope) {
    if (scope === void 0) { scope = ''; }
    var methodDecorator = function (_target, name, desc) {
        var rawValue = desc.value;
        desc.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // 历史原因，类对象上的logger属性名不一样
            var logger = this._logger || this.logger;
            if (typeof (logger === null || logger === void 0 ? void 0 : logger.log) === 'function') {
                // 删除'['和']'
                var argStr = jsonTool.safelyStringify(args).slice(1, -1);
                logger.log("@".concat(scope, ".").concat(name, "(").concat(argStr, ")"));
            }
            return rawValue.apply(this, args);
        };
    };
    return methodDecorator;
}
export var costTimeEmitter = new EventEmitter();
/**
 * 创建“函数调用耗时装饰器”
 * @param scope 函数作用域名，传入成员函数所在的类名
 * @returns MethodDecorator
 */
export function performanceCostDecoratorCreator(scope) {
    if (scope === void 0) { scope = ''; }
    var methodDecorator = function (_target, name, desc) {
        var rawValue = desc.value;
        desc.value = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var instanceId = ((_a = this.config) === null || _a === void 0 ? void 0 : _a.instanceId) || this.playerInstanceId || this.instanceId;
            if (!instanceId) {
                return rawValue.apply(this, args);
            }
            var startTime = performance.now();
            var result = rawValue.apply(this, args);
            var endTime = performance.now();
            costTimeEmitter.emit('done', { instanceId: instanceId, methodName: "".concat(scope, "::").concat(name), time: endTime - startTime });
            return result;
        };
    };
    return methodDecorator;
}
